import Spike from './spike.js'
import Peak from './peak.js'

export default class FindPeak {
    constructor(s) {
        this.signal = s.map(Number);
        this.maxima_indices = [];
        this.minima_indices = [];

        this.peak_indices = null;
        this.trough_indices = null;

        this.overlap = 3;
        this.threads = 4;
    }

    // Method
    reset_indices() {
        this.maxima_indices = [];
        this.minima_indices = [];
    }

    detectPeaks() {
        const p = this.detect(this.signal, "peak");

        this.peak_indices = p.getPeaks();

        return p;
    }

    detectTroughs() {
        let reverse_signal = new Array(this.signal.length).fill(0.0);

        for (let i = 0; i < reverse_signal.length; i++) {
            reverse_signal[i] = 0 - this.signal[i];
        }

        const p = this.detect(reverse_signal, "trough");

        this.trough_indices = p.getPeaks();

        return p;
    }


    // internal function for detecting peaks
    detect(signal, mode) {
        let midpoints = [];
        let left_edge = [];
        let right_edge = [];

        this.reset_indices();

        let i = 1;
        let i_max = signal.length - 1;
        let i_ahead = 0;

        while (i < i_max) {
            if (signal[i - 1] < signal[i]) {
                i_ahead = i + 1;

                while ((i_ahead < i_max) && (signal[i_ahead] == signal[i])) {
                    i_ahead++;
                }

                if (signal[i_ahead] < signal[i]) {
                    left_edge.push(i);
                    right_edge.push(i_ahead - 1);
                    midpoints.push(Math.trunc((i + i_ahead - 1) / 2));
                    i = i_ahead;
                }
            }

            i++;
        }

        const pObj = new Peak(signal,
                              this.convertToPrimitiveInt(midpoints),
                              this.convertToPrimitiveInt(left_edge),
                              this.convertToPrimitiveInt(right_edge),
                              mode);

        return pObj;
    }

    getClosest(arr, val, mode) {
        let closest = -1;

        if (mode == "left") {
            let distance = -1000000;

            for (let i = 0; i < arr.length; i++) {
                if (((arr[i] - val) > distance) && (arr[i] - val) < 0) {
                    distance = arr[i] - val;
                    closest = arr[i];
                }
            }
        }
        else if (mode == "right") {
            let distance = 1000000;

            for (let i=arr.length - 1; i >= 0; i--) {
                if (((arr[i] - val) < distance) && (arr[i] - val) > 0) {
                    distance = arr[i] - val;
                    closest = arr[i];
                }
            }
        }

        return closest;
    }

    getSpikes_ex(signal, peaks, troughs) {
        let left_trough = new Array(peaks.length).fill(0);
        let right_trough = new Array(peaks.length).fill(0);

        for (let i = 0; i < peaks.length; i++) {
            left_trough[i] = this.getClosest(troughs, peaks[i], "left");
            right_trough[i] = this.getClosest(troughs, peaks[i], "right");

            if (left_trough[i] == -1 && i == 0) 
                left_trough[i] = 0;

            if (right_trough[i] == -1 && i == peaks.length - 1) 
                right_trough[i] = signal.length - 1;
        }

        const sObj = new Spike(signal, peaks, left_trough, right_trough);

        return sObj;
    }

    getSpikes() {
        if ((this.peak_indices == null) || (this.trough_indices == null)) {
            this.detectPeaks();
            this.detectTroughs();
        }

        return this.getSpikes_ex(this.signal, this.peak_indices, this.trough_indices);
    }

    // /**
    //  * This method identifies all the spikes in the signal.
    //  * Spikes properties are different from peaks such that, the spike height and width are dependent on their neighbouring troughs.
    //  * @return SpikeObject The list of all the troughs as PeakObject
    //  */
    // public Spike getSpikes() {
    //     if ((this.peak_indices == null) || (this.trough_indices == null)) {
    //         this.detectPeaks();
    //         this.detectTroughs();
    //     }
    //     return this.getSpikes(this.signal, this.peak_indices, this.trough_indices);
    // }

    convertToPrimitiveInt(l) {
        let ret = new Array(l.length).fill(0);

        for (let i = 0; i < ret.length; i++) {
            ret[i] = l[i];
        }

        return ret;
    }
}